import type { ChapterState } from "../experience/chapterDirector";
import type { KnowledgePanel } from "./knowledge";
import { getTerm } from "./knowledge";

type Spot = { term: string; x: number; y: number; from: number; to: number };

const SPOTS: Spot[] = [
  { term: "CANNABIS", x: 28, y: 42, from: 0.2, to: 0.48 },
  { term: "TRICHOME", x: 52, y: 38, from: 0.24, to: 0.5 },
  { term: "INDICA", x: 40, y: 58, from: 0.26, to: 0.5 },
  { term: "SATIVA", x: 68, y: 52, from: 0.28, to: 0.5 },
  { term: "THC", x: 46, y: 48, from: 0.45, to: 0.7 },
  { term: "CBD", x: 62, y: 42, from: 0.46, to: 0.7 },
  { term: "TERPENE", x: 34, y: 66, from: 0.48, to: 0.72 },
  { term: "MYRCENE", x: 74, y: 60, from: 0.5, to: 0.74 },
  { term: "ENDOCANNABINOID", x: 55, y: 70, from: 0.52, to: 0.74 },
  { term: "EDIBLE", x: 42, y: 76, from: 0.66, to: 0.9 },
  { term: "HASHISH", x: 64, y: 72, from: 0.68, to: 0.9 },
  { term: "VAPORIZATION", x: 50, y: 82, from: 0.7, to: 0.92 },
];

const CHAPTER_TERMS: Record<string, string[]> = {
  plant: ["CANNABIS", "TRICHOME", "INDICA", "SATIVA"],
  inside: ["THC", "CBD", "TERPENE", "MYRCENE", "ENDOCANNABINOID"],
  world: ["EDIBLE", "HASHISH", "VAPORIZATION"],
};

export function mountHotspots(host: HTMLElement, panel: KnowledgePanel) {
  const layer = document.createElement("div");
  layer.className = "hotspots";

  const buttons = SPOTS.filter((s) => getTerm(s.term)).map((spot) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "hotspot";
    btn.style.left = `${spot.x}%`;
    btn.style.top = `${spot.y}%`;
    btn.title = spot.term;
    btn.setAttribute("aria-label", `Learn about ${spot.term}`);
    btn.dataset.from = String(spot.from);
    btn.dataset.to = String(spot.to);
    btn.hidden = true;
    btn.addEventListener("click", () => panel.open(spot.term));
    layer.appendChild(btn);
    return btn;
  });

  host.appendChild(layer);

  return {
    layer,
    update(progress: number) {
      buttons.forEach((btn) => {
        const from = Number(btn.dataset.from);
        const to = Number(btn.dataset.to);
        const visible = progress >= from && progress <= to;
        btn.hidden = !visible;
        btn.style.opacity = visible ? "1" : "0";
      });
    },
    updateForChapter(state: ChapterState) {
      const id = state.act.id;
      const allowed = CHAPTER_TERMS[id];
      buttons.forEach((btn) => {
        if (id === "threshold" || id === "arrival" || id === "load") {
          btn.hidden = id !== "threshold";
          return;
        }
        btn.hidden = !(allowed?.includes(btn.title) ?? false);
      });
    },
  };
}
